import React from 'react'
import Header from '../../../components/generals/header'
import stylesIndex from './../../../css/Index.module.css'
import store from '../../../reducer/store'
import styles from '../../../css/reports/Reports.module.css'
import { NavLink } from 'react-router-dom'
import { Button } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import DataTableLazyApps from '../../../components/generals/datatables/dataTableLazyApps'

export default function AppsReport () {
  const { t } = useTranslation('appsReport')
  const { user } = store.getState()
  const role = user.roles

  // Categorias
  const categories = [
    { name: t('category1'), id: 0 },
    { name: t('category2'), id: 1 },
    { name: t('category3'), id: 2 },
    { name: t('category4'), id: 3 },
    { name: t('category5'), id: 4 },
    { name: t('category6'), id: 5 },
    { name: t('category7'), id: 6 },
    { name: t('category8'), id: 7 },
    { name: t('category9'), id: 8 },
    { name: t('category10'), id: 9 }
  ]

  const columns = [
    {
      field: 'app',
      header: t('label1')
    },
    {
      field: 'uninstall',
      header: t('label2')
    },
    {
      field: 'totalTimeSeconds',
      header: t('label3')
    },
    {
      field: 'groupApp',
      header: t('label4')
    }
  ]

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <div>
          <NavLink to="/mdm/reports">
              <Button variant="dark" className={styles.return_btn}>
                <i className="pi pi-arrow-circle-left" style={{ marginRight: '0.5rem' }}></i>
                {t('button')}
              </Button>
          </NavLink>
        </div>
        <div style={{ marginTop: '2rem' }}>
           <DataTableLazyApps
                table="appsReport"
                categories={categories}
                exportsCsv={role?.reportsPage.exportCsvInReport}
                exportsPdf={role?.reportsPage.exportPdfInReport}
                namePdf={t('namePdf')}
                columnsExport={columns}
            />
        </div>
      </div>
    </div>
  )
}
